import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search"]

  connect() {
    this.element.querySelectorAll("select").forEach((select) => {
      select.addEventListener("change", () => this.submit())
    })

    if (this.hasSearchTarget) {
      this.debounceTimer = null
      this.searchTarget.addEventListener("input", () => {
        window.clearTimeout(this.debounceTimer)
        this.debounceTimer = window.setTimeout(() => this.submit(), 350)
      })
    }
  }

  disconnect() {
    window.clearTimeout(this.debounceTimer)
  }

  submit() {
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }
}
